import { useMutation } from '@tanstack/react-query';
import { ArrowRight, Loader2 } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';
import { Card } from '@nesso/ui/primitives/card';
import { FieldError } from '@nesso/ui/primitives/field';

import { createMerchantOnboardingLinkOptions } from '@/entities/merchant';
import { useOpenLinkInNewTab } from '@/shared/lib/use-open-link-in-new-tab';

export function StartOnlinePaymentsCard() {
    const { mutateAsync, isPending } = useMutation(createMerchantOnboardingLinkOptions());
    const { open, hasFailed } = useOpenLinkInNewTab(mutateAsync);

    return (
        <Card className="min-h-[385px] items-center justify-center bg-transparent px-6 text-center">
            <div className="flex flex-col items-center gap-2">
                <h2 className="text-lg font-medium">Process credit card payments inside Nesso</h2>
                <p className="text-sm leading-relaxed text-muted-foreground">
                    2.9% + $0.30 per transaction, HSA/FSA Support
                </p>
            </div>
            <div className="flex flex-col gap-2">
                <Button
                    type="button"
                    className="has-[>svg]:px-4"
                    disabled={isPending}
                    onClick={open}
                >
                    {isPending && <Loader2 className="animate-spin" />}
                    Get Started
                    {!isPending && <ArrowRight />}
                </Button>
                {hasFailed && <FieldError>Couldn't open the application. Try again.</FieldError>}
            </div>
        </Card>
    );
}
